class AlertModal extends React.Component {
  
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal: true
    };
    
  }

  handleHide() {
    this.setState({ showModal: false });
  }
  
  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    return (

      <div className="modal-wrap-alert-modal">
        <div className="modal-container">
          <Modal
            show={this.state.showModal}
            container={this}
            onHide={this.handleHide}
            bsSize="large"
            backdrop="static"
            aria-labelledby="contained-modal-title"
          >
            <Modal.Header>
              <button id="close-modal" type="button" className="close-button" onClick={this.handleHide}>
                <i className="fa fa-times"></i>
              </button>
            </Modal.Header>
            <Modal.Body className="alert-modal-body">
                <p className="alert-modal-message">
                  { this.props.message }
                </p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.props.onClickAgreeButton() }>De acuerdo</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

const Modal = ReactBootstrap.Modal;
const Button = ReactBootstrap.Button;

export default AlertModal;


// WEBPACK FOOTER //
// ./base/components/alertModal.js